import { useEffect } from "react";

import TriageTable from "../../components/triage/TriageTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function TriageList() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Triage",
      desc: "Vehicles with Triage still in progress",
    });
  }, []);

  return <TriageTable />;
}
